/**
 * ALTIORA · Quick Outcome Buttons
 * -----------------------------------------------------------------
 * 3 boutons compacts « Suivie / Ignorée / Réussie » qui enregistrent
 * l'outcome d'une recommandation en un clic — alimente le Learning
 * Engine et Decision Memory.
 */
import { useState } from "react";
import { Check, X, Trophy } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const BUTTONS = [
  { key: "followed",  label: "Suivie",  icon: Check,  color: "#0a2540" },
  { key: "succeeded", label: "Réussie", icon: Trophy, color: "#0a7f42" },
  { key: "ignored",   label: "Ignorée", icon: X,      color: "#8B4E00" },
];

export default function QuickOutcomeButtons({ actionId }) {
  const [selected, setSelected] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (status) => {
    if (busy) return;
    setBusy(true);
    try {
      await api.post(`/strategic-copilot/actions/${actionId}/outcome`,
                     { status, notes: "", impact: {} });
      setSelected(status);
      toast.success(
        status === "succeeded" ? "Réussie · l'apprentissage progresse" :
        status === "followed"  ? "Marquée comme suivie" :
        "Marquée comme ignorée"
      );
    } catch (err) {
      // 404 si l'action n'a pas encore été capturée dans Decision Memory
      const msg = err?.response?.status === 404
        ? "Cette action n'a pas encore été enregistrée. Rafraîchissez votre briefing."
        : "Impossible d'enregistrer l'outcome.";
      toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-1" data-testid={`quick-outcome-${actionId}`}>
      {BUTTONS.map((b) => {
        const Icon = b.icon;
        const active = selected === b.key;
        return (
          <button
            key={b.key}
            type="button"
            onClick={() => submit(b.key)}
            disabled={busy || !!selected}
            data-testid={`quick-outcome-${b.key}-${actionId}`}
            className="inline-flex items-center gap-1 text-[10px] px-2 py-1 rounded transition"
            style={{
              background: active ? b.color : "transparent",
              color: active ? "#faf6ea" : b.color,
              border: `1px solid ${b.color}66`,
              opacity: selected && !active ? 0.4 : 1,
              cursor: (busy || !!selected) ? "default" : "pointer",
            }}
          >
            <Icon size={10} /> {b.label}
          </button>
        );
      })}
    </div>
  );
}
